var utils = require("./utils");

var $srcElement = $(this);
var $hiddenInput = $(".js-grants-payment-methods");

var paymentMethodObject = {};

var objCounter = 0;

var $content = $("#grant_payment_methods_table").children("tbody");

function isInOrganisationPage() {
  return $("#organisation-page").length > 0;
}

//        $srcElement.find('.js-add').click(addClickEvent);

if (isInOrganisationPage()) {
  //                    $srcElement.find('.js-add').click(addClickEvent);
  $(".js-addPaymentMethod").on("click", function (event) {
    var newDataObject = getDataInput();
    if (newDataObject) {
      addToPaymentMethodObject(newDataObject);
      renderContent();
      updateHiddenInput();
      resetInputs();
    }
  });
  storeExistingDomContent();
  renderContent();
  updateHiddenInput();
  //                    updateSelect();

}

function addClickEvent(e) {}

function getDataInput() {
  //            var orgElement = $srcElement.find(':selected');
  //            console.log("when selected");
  //            var orgId = $("#orgName").val();
  //            console.log(orgId);
  var grant =
    $("#grants option:selected").text() +
    "|" +
    $("#grants option:selected").val();

  var payment_method = $("#payment_methods option:selected").text();
  //        var date = $srcElement.find(':text').not(':hidden').val();

  var obj = {};

  if (grant !== "" && payment_method !== "") {
    //                obj[sapVendorCode]={};
    obj[grant] = payment_method;

    //            $('#orgName').empty();
    //            console.log($('#orgName').val());
    //            console.log($("#orgName option:selected").empty().append('<option selected="selected" value="whatever">text</option>'));
    return obj;
  }

  return false;
}

function addToPaymentMethodObject(obj) {
  $.extend(paymentMethodObject, obj);
}

function renderContent() {
  $("#grant_payment_methods_table").children("tbody").replaceWith(getTbody());
}

function updateHiddenInput() {
  $hiddenInput.val(JSON.stringify(mapObject(paymentMethodObject)));
}

function mapObject(data) {
  var obj = [];

  for (var key in data) {
    var item = {};
    item.value = data[key]; //CHeck this///////////////////////////////////////
    item.grantName = key.split("|")[0];
    item.grantUuid = key.split("|")[1]; //CHeck this///////////////////////////////////////

    obj.push(item);
  }

  return obj;
}

function resetInputsReference() {
  $($srcElement.find(":text").not(":hidden")).val("");

  var orgText = $("#orgName option:selected").text();
  var orgValue = $("#orgName option:selected").val();
  var newOrg = $('<option value="' + orgValue + '">' + orgText + "</option>");
  $("#orgName option:selected").empty();
  $("#orgName").append(newOrg);
  $("#orgName").trigger("chosen:updated");

  var reasonText = $("#extensionReason option:selected").text();
  var reasonValue = $("#extensionReason option:selected").val();
  var newReason = $(
    '<option value="' + reasonValue + '">' + reasonText + "</option>",
  );
  $("#extensionReason option:selected").empty();
  $("#extensionReason").append(newReason);
  $("#extensionReason").trigger("chosen:updated");
}
function resetInputs() {
  var newVendorCodeTypeText = $(
    "#sap_vendor_codes_type option:selected",
  ).text();
  var newVendorCodeTypeValue = $(
    "#sap_vendor_codes_type option:selected",
  ).val();
  var newVendorCodeType = $(
    '<option value="' +
      newVendorCodeTypeValue +
      '">' +
      newVendorCodeTypeText +
      "</option>",
  );

  $("#sap_vendor_codes_type option:selected").empty();
  $("#sap_vendor_codes_type").append(newVendorCodeType);
  $("#sap_vendor_codes_type").trigger("chosen:updated");
}

function getTbody() {
  var obj = paymentMethodObject;
  var $content = $("<tbody />");

  var $link;

  $.each(obj, function (key, value) {

    $link = $(
      '<td class="govuk-table__cell"><button type="button" class="js-removePaymentMethod" data-paymentmethodid="' +
        key +
        '">remove</button></td>',
    ).on("click", removeClickEvent);

    //
    var $row = $('<tr class="govuk-table__row"/>')
      .append('<td class="govuk-table__cell">' + key.split("|")[0] + "</td>")
      .append('<td class="govuk-table__cell">' + obj[key] + "</td>")
      .append($link);
    //
    $content.append($row);
    //
  });

  return $content;
}

function removeClickEvent(e) {
  removeFromPaymentMethodObject($(e.target).data("paymentmethodid"));
  renderContent();
  updateHiddenInput();
}

function removeFromPaymentMethodObject(key) {
  delete paymentMethodObject[key];
}

function storeExistingDomContent() {
  var obj = getExistingDomContent();
  addToPaymentMethodObject(obj);
}

function getExistingDomContent() {
  var obj = {};
  $($content)
    .find("tr")
    .each(function () {
      //            var id = $(this).attr('id');
      //            console.log("in getExistingDomMethod, id--"+id);
      var $td = $("td", this);

      //            obj[sapVendorCode] = $td.eq(0).text();

      var index = $td.eq(0).text();
      obj[index] = $td.eq(1).text();
    });

  return obj;
}
